const drugs = [
  "Total lystae",
  "Total protein",
  "Total RNA",

  "Nucl. protein",
  "Cyto. protein",

  "Nucl. lysate",
  "Cyto. lysate",

  'DMSO',
  'Tamoxifen',
  'Paclitaxel',
  'Cisplatin',
  'Rapamycin',
  'LPS',
  'Colchicine',
  'Curcumin',
  'Streptomycin',
  'Tetracycline',
  'Caffeine',
  'Hydrogen Peroxide',
  'Gleevec',
  'Aspirin',
  'Ibuprofen',
  'Paracetamol',
  'Methotrexate',
  'Insulin',
  'Erythromycin',
  'Warfarin',
  'Ciprofloxacin',
  'Rituximab',
  'Trastuzumab',
  'Bevacizumab',
  'Dexamethasone',
  'Montelukast',
  'Clopidogrel',
  'Naproxen',
  'Valacyclovir',
];

export default drugs;
